import React, { useState, useRef, useEffect } from "react";

import "./TH.css";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { uploadAbacusFile, closeAlert } from "../Redux/THSlice";
import { getCurrentMonth } from "../Redux/BussinessPOCSlice";
import { Typography } from "@mui/material";
import { Alert } from "@mui/material";
import { useMsal } from "@azure/msal-react";

function UploadAbacus() {
 const [file, setFile] = useState("");
 const [statusMessage, setStatusMessage] = useState("");
 const [loading, setLoading] = useState(false);
 const [severity, setSeverity] = useState('')
 const [uploadclicked, setUploadClicked] = useState(false)
 const [activeButton, setActiveButton] = useState(false);

 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const [username, setuserName] = useState();

 const response = useSelector((state) => state.traininghost.responseMessage);
 const isUploaded = useSelector((state) => state.traininghost.isUploaded);
 const {isLoaded, isDataSentSuccess, isDataSentFailure} = useSelector((state) => state.traininghost) ?? false;

 const dispatch = useDispatch();

 const ref = useRef();
 const saveFile = (e) => {
  setStatusMessage("");
  setFile(e.target.files[0]);
 };
useEffect(() => {
if(uploadclicked){
  if(isLoaded){
  setSeverity("warning")
  setStatusMessage("File uploading... Please wait.")
  } else if(isDataSentSuccess){
    setSeverity("success")
    setStatusMessage("File uploaded successfully!")
  }else{
    setSeverity("error")
    setStatusMessage("Error uploading file.")
  }
}
}, [isLoaded, isDataSentSuccess, isDataSentFailure])
useEffect(() => {
  if (activeAccount) {
   console.log("Active acocunt is", activeAccount.idTokenClaims.enterpriseID);
   setuserName(activeAccount.idTokenClaims.enterpriseID);  
  } else {
   setuserName(null);
  }
 }, [activeAccount]);
 const handleUpload = () => {
  if (!file) {
    setSeverity("warning")
   setStatusMessage("Please select a file.");
   return;
  }
  setUploadClicked(true)
  const formData = new FormData();
  formData.append("file", file);
  dispatch(uploadAbacusFile(formData, username));
 };
 const sampleAbacusDownload = async () => {
    try {
      let fileUrl;
      let fileName;
        fileUrl = process.env.PUBLIC_URL + "/template/SampleAbacus.xlsx";
        fileName = `SampleAbacus.xlsx`
      const response = await fetch(fileUrl);
      const blob = await response.blob();
  
     const blobUrl = window.URL.createObjectURL(new Blob([blob]));
  
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${fileName}`; // Name of the file to be downloaded
      link.target = "_blank";
  
      // Trigger the download
      document.body.appendChild(link);
      link.click();
  
      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
 }
 useEffect(() => {
  dispatch(getCurrentMonth());
 }, []);
 return (
  <div>
   <Box
   sx={{
    display: 'flex',
    justifyContent:'space-between',
    marginTop: "30px"
  }}
   >
    {uploadclicked ? (
     <Alert
      style={{
       maxWidth: "fit-content",
       position: "fixed",
       top: "150px",
       right: "0px",
      }}
      severity = {severity}
      onClose={() => {
       setUploadClicked(false)
      }}
     >
      {statusMessage}
     </Alert>
    ) : null}

    <Stack spacing={2} direction={"row"} alignItems={"center"}>
     <input type="file" accept=".xlsx" ref={ref} id="file" onChange={saveFile} hidden />
     <label for="file" className="th-mainData">
      Select File
     </label>
     <span className="th-file_caption">
      {file.name != undefined && file.name != null ? file.name : "No File Selected"}
     </span>
     <Button
      className={
       loading === false
        ? "th-upload_button_modal_active"
        : "th-upload_button_modal_inactive"
      }
      sx={{ minWidth: "30px !important" }}
      onClick={handleUpload}
     >
      Upload
      {/* {loading === false ? "Upload" : "Cancel"} */}
     </Button>
    </Stack>
    <Stack>
    <div className="button_container_abacus">
                <Button
                 className={
                  activeButton ? "abacus_download_button_active" : "abacus_download_button_inactive"
                 }
                 variant="contained"
                 sx={{marginRight: '20px'}}
                 onClick={() => {
                  setActiveButton(!activeButton);
                  //window.open("../../template/Training Nominations Template.xlsx");
                 }}
                >
                 <a
                  // href="/template/TrainingNominationsTemplate.xlsx"
                  href="#"
                  onClick={sampleAbacusDownload}
                  className={activeButton ? "abacus_download_link" : "abacus_download_link_inactive"}
                 >
                  Download Sample
                 </a>
                 {activeButton ? (
                  <img
                   src="/images/Home/download-icon-white.png"
                   alt="icon"
                   className="abacus_download_img"
                  />
                 ) : (
                  <img
                   src="/images/Home/download-icon.png"
                   alt="icon"
                   className="abacus_download_img"
                  />
                 )}
                </Button>
                </div>
    </Stack>
   </Box>
  </div>
 );
}

export default UploadAbacus;